import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean | string;
  success?: boolean;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  error,
  success,
  helperText,
  leftIcon,
  rightIcon,
  ...props
}, ref) => {
  const hasError = Boolean(error);
  return <div className="w-full relative" data-id="element-328">
        <div className="relative" data-id="element-329">
          {leftIcon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" data-id="element-330">
              {leftIcon}
            </div>}

          <input type={type} className={cn('flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200', leftIcon && 'pl-10', rightIcon && 'pr-10', hasError && 'border-destructive focus-visible:ring-destructive', success && 'border-success focus-visible:ring-success', className)} ref={ref} aria-invalid={hasError} aria-describedby={helperText ? `${props.id}-description` : undefined} {...props} data-id="element-331" />

          {rightIcon ? <div className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground" data-id="element-332">
              {rightIcon}
            </div> : hasError ? <div className="absolute right-3 top-1/2 -translate-y-1/2 text-destructive pointer-events-none" data-id="element-333">
              <AlertCircle className="h-4 w-4" data-id="element-334" />
            </div> : success ? <div className="absolute right-3 top-1/2 -translate-y-1/2 text-success pointer-events-none" data-id="element-335">
              <CheckCircle2 className="h-4 w-4" data-id="element-336" />
            </div> : null}
        </div>

        {helperText && <p id={`${props.id}-description`} className={cn('text-xs mt-1.5', hasError ? 'text-destructive' : 'text-muted-foreground')} data-id="element-337">
            {typeof error === 'string' ? error : helperText}
          </p>}
      </div>;
});
Input.displayName = 'Input';
export { Input };